/**
 * Services Page - Placeholder
 * Future: per-business service CRUD
 */

import { Container, Box, Typography } from '@mui/material';

export function ServicesPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Services
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Service management coming soon. This will provide per-business CRUD operations for
          services.
        </Typography>
      </Box>
    </Container>
  );
}
